import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateForm } from "../../../store/selfServiceSlice";

/**
 * @desc Watch and update self service form.
 */
export const useWatchForm = ({ watch }) => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Dispatch store updates on form changes.
   */
  const handleWatch = useCallback(
    (value, { name }) => {
      if (name) {
        dispatch(
          updateForm({
            [name]: value[name],
          })
        );
      }
    },
    [dispatch]
  );

  // SIDE EFFECTS -------------------------------------------------------------

  /**
   * @desc Subscribe to form changes.
   */
  useEffect(() => {
    const subscription = watch(handleWatch);

    return () => subscription.unsubscribe();
  }, [watch, handleWatch]);
};
